import { render, staticRenderFns } from "./Visas.vue?vue&type=template&id=7af6198e&scoped=true&"
import script from "./Visas.vue?vue&type=script&lang=js&"
export * from "./Visas.vue?vue&type=script&lang=js&"
import style0 from "./Visas.vue?vue&type=style&index=0&id=7af6198e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af6198e",
  null
  
)

export default component.exports